// extracted by mini-css-extract-plugin
export default {"shimmer":"TransactionTypeBadge_shimmer__oYd1G","dark_shimmer":"TransactionTypeBadge_dark_shimmer__yiUHV","badge":"TransactionTypeBadge_badge__BNVRi"};